import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import Services from "@/components/Services";


const Index = () => {
  return (
    <div className="min-h-screen">
      <SEO
        title="Award-Winning Cyber Security UK | 24/7 vCISO & Emergency Response | 4FOX Security"
        description="Expert cyber security for UK businesses. 24/7 emergency response, fractional CISO from £2,500/month, Cyber Essentials certification. 98% pass rate. Serving 50+ UK organisations."
        canonical="https://4fox.uk/"
        localAreas={["Somerset", "North Somerset", "Weston-super-Mare", "Bristol", "South Gloucestershire"]}
        schema={{
          "@context": "https://schema.org",
          "@type": "Organisation",
          "name": "4FOX Security",
          "url": "https://4fox.uk",
          "logo": "https://4fox.uk/4fox-logo-optimized.png",
          "description": "Expert fractional CISO services and cyber security consultancy for growing UK businesses",
          "email": "hello@4fox.uk",
          "areaServed": [
            {
              "@type": "Country",
              "name": "United Kingdom"
            },
            {
              "@type": "State",
              "name": "Somerset"
            },
            {
              "@type": "State",
              "name": "North Somerset"
            },
            {
              "@type": "City",
              "name": "Weston-super-Mare"
            },
            {
              "@type": "City",
              "name": "Bristol"
            },
            {
              "@type": "State",
              "name": "South Gloucestershire"
            }
          ],
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "GB"
          },
          "sameAs": ["https://www.linkedin.com/company/4foxsecurity/"]
        }}
      />
      <Navbar />
      <Hero />
      
      {/* Service Areas Section */}
      <section className="py-16 bg-muted/50">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-4xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Serving Somerset, Bristol & Beyond
            </h2>
            <p className="text-lg text-muted-foreground mb-6">
              Based in Weston-super-Mare, we provide expert cyber security services to businesses across 
              <span className="font-semibold text-foreground"> Somerset, North Somerset, Bristol, and South Gloucestershire</span>, 
              with nationwide coverage throughout the United Kingdom.
            </p>
            <p className="text-muted-foreground">
              Whether you're a local SME in the South West or a growing business anywhere in the UK, 
              we deliver the same high-quality fractional CISO and cyber security expertise.
            </p>
          </div>
        </div>
      </section>
      
      <Services />
      
      <Footer />
    </div>
  );
};

export default Index;
